module.exports = __webpack_public_path__ + "static/media/EUSIFP20142020.03f52a3d.png";